export enum EmbeddedRh24MessageTypes {
  RH24_EMBEDDED_SETUP = 'RH24_EMBEDDED_SETUP',
  RH24_EMBEDDED_SEARCH_PARAMS_CHANGED = 'RH24_EMBEDDED_SEARCH_PARAMS_CHANGED',
}
